<template>
    <v-menu offset-x v-model="is_show_parent_menu">
        <template v-slot:activator="{ on }">
            <v-list-item 
                link
                dense
                v-on="on" @click="openParentMenu"
                class="mr-0 pr-0"
                :style="{
                    'backgroundColor': item_bg_color
                }"
            >

                <v-list-item-icon
                    class="mr-4 mt-3 mb-3"
                >
                    <v-icon
                        :color="item_text_color"
                    >
                    {{item.icon}}
                    </v-icon>
                </v-list-item-icon>

                <v-list-item-content
                >
                    <v-list-item-title 
                        :style="{
                            'color': item_text_color
                        }"
                    >
                        {{item.title}}
                    </v-list-item-title>

                </v-list-item-content>

                <v-list-item-action
                >
                    <v-icon :color="item_text_color">mdi-chevron-right</v-icon>
                </v-list-item-action>
            </v-list-item>	
        </template>


        <v-list
        >
            <v-list-item
                dense
                v-for="(sub_item, idx) in item.sub_items"
                :key="idx"
                @click.stop.prevent="callback(sub_item)" 
            >
                {{sub_item.title}}
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>

export default {
    name: "Submenu",
    props: {
        item: Object,
        activate_setting: Object
    },
    data () {
        return {
            is_show_parent_menu: false,

        }
    },
    methods: {
        openParentMenu: function(){
            this.is_show_parent_menu = true
        },
        callback: function(sub_item){
            this.is_show_parent_menu = false
            this.$emit('selectItem',sub_item)
        }

    },
    computed: {
        item_bg_color: function(){
            let default_color = 'transparent'
            if (this.$route.path.includes(this.activate_setting.activate_path)) {
                default_color = this.activate_setting.background_color
            }
            return default_color
        },
        item_text_color: function(){
            let default_color = '#FFFFFF'
            if (this.$route.path.includes(this.activate_setting.activate_path)) {
                default_color = this.activate_setting.text_color
            }
            return default_color
        }
    }
}

</script>
<style scoped>
.item-activate {
  background: #FFF;
}
.item-activate-text {
  color: #353f4d !important;
}

</style>